<template>
    <div class="card h-100 bg-white radius-20 p-0 border-0">
        <img src="/images/new_course_bg.jpeg" alt="" class="card-img-top">
        <div class="card-body px-5 py-3">
            <h2 class="card-title custom-card-title">Se ha creado con éxito el curso <strong class="course-name">"{{ course?.name }}"</strong></h2>
            <p>El nuevo curso quedó guardado y está disponible en el listado de cursos propios</p>

            <a @click="resetCourseStep" class="btn btn-outline-primary px-5 py-2 rounded-8 mx-auto d-block" style="width: fit-content;">
                Ver lista de cursos
            </a>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['course'],
        methods: {
            resetCourseStep(){
                this.$emit('onResetStep');
                window.scrollTo({ top: 0, behavior: 'smooth'});
            }
        }
    }
</script>
<style>
    .radius-20{
        border-radius: 20px;
    }

    .custom-card-title{
        color: #1A0054;
        font-weight: 700;
        font-size: 35px;
    }
</style>
